// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page .ticket-form .form-grid .input-field-wrap .input-field {
  border: 1px solid var(--app-mid-lighter-2);
  border-radius: 5px;
  --padding-start: 8px;
  --padding-end: 8px;
}

.pg-footer {
  border-top: 1px solid var(--app-mid-lighter-2);
  padding: 10px 20px;
  display: flex;
  justify-content: space-between;
}
.pg-footer .foot-btn {
  margin: 0;
  font-weight: 600;
}
.pg-footer .foot-btn.mw-120 {
  min-width: 120px;
}
.pg-footer::before {
  content: normal;
}

.page .ticket-form .form-grid .input-field-wrap.w-stacked-lbl .input-field-lbl {
  word-break: break-all;
  word-break: break-word;
}

.page .ticket-form .form-grid .form-grid-btns .attachment .attachment-text {
  white-space: nowrap;
  overflow-x: hidden;
  text-overflow: ellipsis;
}

.ion-activatable {
  position: relative;
}
.ion-activatable.ripple-bounded {
  overflow: hidden;
}
.ion-activatable > ion-ripple-effect.ripple {
  /*&.main-soft {
    color: var(--app-main-soft);
  }*/
}
.ion-activatable > ion-ripple-effect.ripple.contr {
  color: var(--app-contr);
}
.ion-activatable > ion-ripple-effect.ripple.darkest {
  color: var(--app-darkest);
}
.ion-activatable > ion-ripple-effect.ripple.lightest {
  color: var(--app-lightest);
}
.ion-activatable > ion-ripple-effect.ripple.main {
  color: var(--app-main);
}
.ion-activatable > ion-ripple-effect.ripple.main-darker {
  color: var(--app-main-darker);
}
.ion-activatable > ion-ripple-effect.ripple.main-softer {
  color: var(--app-main-softer);
}
.ion-activatable > ion-ripple-effect.ripple.main-strong {
  color: var(--app-main-strong);
}
.ion-activatable > ion-ripple-effect.ripple.mid-light {
  color: var(--app-mid-light);
}
.ion-activatable > ion-ripple-effect.ripple.mid-lighter {
  color: var(--app-mid-lighter);
}
.ion-activatable > ion-ripple-effect.ripple.mid-lighter-2 {
  color: var(--app-mid-lighter-2);
}

.page-title-header-custom {
  min-height: 56px;
  display: flex;
  align-items: center;
  background-color: var(--app-main-strong);
  color: var(--app-base);
  box-shadow: 0 1px 2px rgba(var(--app-cover-rgb), 0.6);
}
.page-title-header-custom .head-btn {
  margin: 0;
  border-radius: 50%;
  --border-radius: 50%;
}
.page-title-header-custom .ptc-title {
  flex: 1;
  padding: 0 20px;
  letter-spacing: 0.0125em;
  font-size: 20px;
  font-weight: 600;
}
.page-title-header-custom .ptc-step {
  margin-right: 20px;
  border: 1px solid var(--app-base);
  border-radius: 99px;
  padding: 2px 6px;
  font-size: 14px;
  font-weight: 500;
  display: flex;
  align-items: center;
}
.page-title-header-custom .ptc-step .mini-lbl {
  display: none;
  padding-top: 1px;
  padding-right: 5px;
  font-size: 11px;
  text-transform: uppercase;
}
@media (min-width: 360px) {
  .page-title-header-custom .ptc-step .mini-lbl {
    display: initial;
  }
}

.page-wrapper {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.page-wrapper .page-wrap-scrollable {
  flex: 1;
  overflow-y: auto;
  display: flex;
  align-items: flex-start;
  background-color: var(--app-light);
}
.page-wrapper .page-wrap-scrollable .page {
  margin: 0 auto;
  width: 100%;
  max-width: 800px;
}

.page {
  padding: 20px 20px 50px;
}
.page .page-title {
  margin-bottom: 30px;
}
.page .ticket-form .form-grid .item {
  --padding-top: 0;
  --padding-bottom: 0;
  --padding-start: 0;
  --padding-end: 0;
  width: calc(100% + 16px);
  visibility: hidden;
}
.page .ticket-form .form-grid .item .input-field {
  visibility: visible;
  margin-top: 0;
  --padding-top: 10px;
  --padding-bottom: 10px;
  --padding-start: 10px;
  --padding-end: 10px;
}
.page .ticket-form .form-grid .form-grid-btns {
  padding-top: 30px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.page .ticket-form .form-grid .form-grid-btns .attachment {
  margin-bottom: 5px;
  max-width: 100%;
  display: flex;
  align-items: center;
}
.page .ticket-form .form-grid .form-grid-btns .attachment .attachment-text {
  flex: 1;
  color: var(--app-mid);
}
.page .ticket-form .form-grid .form-grid-btns .attachment .line-btn {
  margin: 0;
  margin-left: 5px;
  --border-radius: 50%;
  border-radius: 50%;
  height: auto;
  --padding-start: 0;
  --padding-end: 0;
}
.page .ticket-form .form-grid .form-grid-btns .attachment .line-btn .btn-icon {
  margin: 5px;
  font-size: 18px;
}
.page .ticket-form .form-grid .form-grid-btns .t1-btn {
  margin: 0;
  margin-bottom: 20px;
  margin-left: -15px;
  --padding-start: 15px;
  --padding-end: 15px;
  height: 34px;
  font-size: 15px;
  text-transform: none;
}
.page .ticket-form .form-grid .form-grid-btns .t1-btn .btn-icon {
  margin-left: 20px;
  color: var(--app-main);
  font-size: 20px;
}
.page .ticket-form .form-grid .input-field-wrap {
  display: flex;
  align-items: center;
  position: relative;
  /* .input-field-lg {
  	@extend %input-lg;

  	&.fz-15 {
  		font-size: 15px;
  	}

  	&.mxw-300 {
  		max-width: 300px;
  	}
  	&.mxw-350 {
  		max-width: 350px;
  	}

  } */
  /* .input-help {
  	margin-left: 12px;

  	// color: rgba(var(--app-main-softer-rgb), .7);
  	color: var(--app-main-softer);

  	font-size: 22px;

  	&.ml-15 {
  		margin-left: 15px;
  	}
  	&.ml-20 {
  		margin-left: 20px;
  	}
  } */
  /* .input-unit {
  	margin-left: 12px;

  	color: rgba(var(--app-mid-rgb), .7);

  	font-size: 14px;
  	font-weight: 500;
  } */
}
.page .ticket-form .form-grid .input-field-wrap ion-textarea {
  margin-top: 0;
}
.page .ticket-form .form-grid .input-field-wrap .input-error {
  position: absolute;
  top: 100%;
  color: var(--app-danger);
  padding: 2px;
}
.page .ticket-form .form-grid .input-field-wrap .input-field {
  font-size: 16px;
  background-color: var(--app-base);
}
.page .ticket-form .form-grid .input-field-wrap .input-field.if-textarea {
  margin-top: 0;
}
.page .ticket-form .form-grid .input-field-wrap .input-field.if-textarea.if-textarea-msg.show-standard {
  display: none;
}
@media (min-height: 800px) {
  .page .ticket-form .form-grid .input-field-wrap .input-field.if-textarea.if-textarea-msg.show-on-sm {
    display: none;
  }
  .page .ticket-form .form-grid .input-field-wrap .input-field.if-textarea.if-textarea-msg.show-standard {
    display: initial;
  }
}
.page .ticket-form .form-grid .input-field-wrap .input-field.border-danger {
  border-color: var(--app-danger);
}
.page .ticket-form .form-grid .input-field-wrap.w-stacked-lbl {
  flex-direction: column;
  align-items: flex-start;
}
.page .ticket-form .form-grid .input-field-wrap.w-stacked-lbl .input-field-lbl {
  color: var(--app-mid-light);
  font-weight: 500;
}
.page .ticket-form .form-grid .input-field-wrap.w-stacked-lbl .input-field-lbl.mb-0 {
  margin-bottom: 0;
}
.page .ticket-form .form-grid .input-field-wrap.w-stacked-lbl .input-field-lbl.mb-5 {
  margin-bottom: 5px;
}
.page .ticket-form .form-grid .input-field-wrap.w-stacked-lbl .input-field-lbl.mb-10 {
  margin-bottom: 10px;
}
.page .ticket-form .form-grid .input-field-wrap.w-stacked-lbl .input-field-lbl.mb-15 {
  margin-bottom: 15px;
}
.page .ticket-form .form-grid .input-field-wrap.w-stacked-lbl .input-field-lbl.mb-20 {
  margin-bottom: 20px;
}
.page .ticket-form .form-grid .input-field-wrap.w-stacked-lbl .input-field-lbl.mb-25 {
  margin-bottom: 25px;
}
.page .ticket-form .form-grid .input-field-wrap.w-stacked-lbl .input-field-lbl.mb-30 {
  margin-bottom: 30px;
}
.page .ticket-form .form-grid .input-field-wrap.mb-0 {
  margin-bottom: 0;
}
.page .ticket-form .form-grid .input-field-wrap.mb-5 {
  margin-bottom: 5px;
}
.page .ticket-form .form-grid .input-field-wrap.mb-10 {
  margin-bottom: 10px;
}
.page .ticket-form .form-grid .input-field-wrap.mb-15 {
  margin-bottom: 15px;
}
.page .ticket-form .form-grid .input-field-wrap.mb-20 {
  margin-bottom: 20px;
}
.page .ticket-form .form-grid .input-field-wrap.mb-25 {
  margin-bottom: 25px;
}
.page .ticket-form .form-grid .input-field-wrap.mb-30 {
  margin-bottom: 30px;
}
.page .ticket-form .form-grid .grid-col-2 {
  grid-column: span 2;
}
.page .ticket-form .form-grid .grid-row-2 {
  grid-row: span 2;
}
.page .ticket-form .form-btns {
  padding-top: 20px;
  display: flex;
  align-items: center;
}
.page .ticket-form .form-btns .tfb-btn {
  margin: 0;
  font-weight: 600;
  font-size: 16px;
}
.page .ticket-form .form-btns .tfb-btn .btn-icon {
  margin-left: 12px;
  font-size: 16px;
}
.page .ticket-form.style-2 {
  display: flex;
  justify-content: center;
}
.page .ticket-form.style-2 .form-grid {
  width: 100%;
  max-width: 500px;
}

.pg-footer .foot-btn {
  min-width: 130px;
}`, "",{"version":3,"sources":["webpack://./src/theme/mobile/desktop.scss","webpack://./src/app/pages/mobile/common/ticket-add/ticket-add.page.scss","webpack://./src/theme/mobile/_pageTitleHeaderCustom.scss"],"names":[],"mappings":"AAmLA;EAYE,0CA5Lc;EA6Ld,kBAAA;EAIA,oBAAA;EACA,kBAAA;AChMF;;ADgNA;EACE,8CAnNc;EAoNf,kBAAA;EAEA,aAAA;EACA,8BAAA;AC9MD;ADgNC;EACC,SAAA;EACE,gBAAA;AC9MJ;ADkNI;EACE,gBAAA;AChNN;ADoNC;EACC,eAAA;AClNF;;AD4OA;EACE,qBAAA;EAEA,sBAAA;AC1OF;;AD6OA;EACE,mBAAA;EACA,kBAAA;EACA,uBAAA;AC1OF;;ADsQA;EACE,kBAAA;ACnQF;ADqQE;EACE,gBAAA;ACnQJ;ADuQE;EAwBE;;IAAA;AC1RJ;ADoQI;EACE,uBAAA;AClQN;ADsQI;EACE,yBAAA;ACpQN;ADuQI;EACE,0BAAA;ACrQN;ADyQI;EACE,sBAAA;ACvQN;AD0QI;EACE,6BAAA;ACxQN;AD+QI;EACE,6BAAA;AC7QN;ADgRI;EACE,6BAAA;AC9QN;ADkRI;EACE,2BAAA;AChRN;ADmRI;EACE,6BAAA;ACjRN;ADoRI;EACE,+BAAA;AClRN;;ACvEA;EACC,gBAAA;EAEA,aAAA;EACA,mBAAA;EAEA,wCAAA;EACA,sBAAA;EAEA,qDAAA;ADuED;ACpEC;EACC,SAAA;EACA,kBAAA;EACA,oBAAA;ADsEF;AClEC;EACC,OAAA;EACA,eAAA;EAEA,wBAAA;EACA,eAAA;EACA,gBAAA;ADmEF;AC/DC;EACC,kBFEQ;EEAR,iCAAA;EACA,mBAAA;EACA,gBAAA;EAEA,eAAA;EACA,gBAAA;EAEA,aAAA;EACA,mBAAA;AD8DF;AC3DE;EACC,aAAA;EAEA,gBAAA;EACA,kBAAA;EAEA,eAAA;EACA,yBAAA;AD2DH;ACxDE;EACC;IACC,gBAAA;ED0DF;AACF;;AAzGA;EACC,YAAA;EAEA,aAAA;EACA,sBAAA;AA2GD;AAzGC;EACC,OAAA;EACA,gBAAA;EAEA,aAAA;EACA,uBAAA;EAEA,kCAAA;AAyGF;AAvGE;EACC,cAAA;EACA,WAAA;EACA,gBDZgB;ACqHnB;;AAjGA;EACC,uBDDQ;ACqGT;AAhGC;EACC,mBAAA;AAkGF;AArFG;EAEC,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EAKA,wBAAA;EACA,kBAAA;AAkFJ;AAhFI;EACC,mBAAA;EACA,aAAA;EAKA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,mBAAA;AA8EL;AAzEG;EACC,iBAAA;EAEA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;AA0EJ;AAxEI;EACC,kBAAA;EACA,eAAA;EAEA,aAAA;EACA,mBAAA;AAyEL;AAtEK;EACC,OAAA;EAEA,qBAAA;AAuEN;AAjEK;EACC,SAAA;EACA,gBAAA;EAEA,oBAAA;EACA,kBAAA;EAEA,YAAA;EAGA,kBAAA;EACA,gBAAA;AA+DN;AA7DM;EACC,WAAA;EACA,eAAA;AA+DP;AA1DI;EACC,SAAA;EACA,mBAAA;EAGA,kBAAA;EAEA,qBAAA;EACA,mBAAA;EAEA,YAAA;EAGA,eAAA;EACA,oBAAA;AAsDL;AApDK;EACC,iBAAA;EACA,sBAAA;EACA,eAAA;AAsDN;AA3CG;EACC,aAAA;EACA,mBAAA;EAIA,kBAAA;EA4DA;;;;;;;;;;;;;;KAAA;EAiBA;;;;;;;;;;;;;;KAAA;EAiBA;;;;;;;KAAA;AAdJ;AA9EI;EACE,aAAA;AAgFN;AA9EI;EACE,kBAAA;EACA,SAAA;EACA,wBAAA;EACA,YAAA;AAgFN;AA5EI;EAGC,eAAA;EACA,iCAAA;AA4EL;AAjEK;EACC,aAAA;AAmEN;AA7DO;EACC,aAAA;AA+DR;AA5DO;EACC;IACC,aAAA;EA8DP;EA5DM;IACC,gBAAA;EA8DP;AACF;AAtDK;EACC,+BAAA;AAwDN;AANI;EACC,sBAAA;EACA,uBAAA;AAQL;AANK;EAIC,2BAAA;EAGA,gBAAA;AAGN;AADM;EACC,gBAAA;AAGP;AADM;EACC,kBAAA;AAGP;AADM;EACC,mBAAA;AAGP;AADM;EACC,mBAAA;AAGP;AADM;EACC,mBAAA;AAGP;AADM;EACC,mBAAA;AAGP;AADM;EACC,mBAAA;AAGP;AASI;EACC,gBAAA;AAPL;AASI;EACC,kBAAA;AAPL;AASI;EACC,mBAAA;AAPL;AASI;EACC,mBAAA;AAPL;AASI;EACC,mBAAA;AAPL;AASI;EACC,mBAAA;AAPL;AASI;EACC,mBAAA;AAPL;AAiBG;EACC,mBAAA;AAfJ;AAiBG;EACC,gBAAA;AAfJ;AAsBE;EACC,iBAAA;EAEA,aAAA;EACA,mBAAA;AArBH;AAuBG;EACC,SAAA;EACA,gBAAA;EAEA,eAAA;AAtBJ;AAwBI;EACC,iBAAA;EACA,eAAA;AAtBL;AA6BE;EACC,aAAA;EACA,uBAAA;AA3BH;AA6BG;EACC,WAAA;EACA,gBAAA;AA3BJ;;AA0CC;EACC,gBAAA;AAvCF","sourcesContent":["\n\n\n$borderDivider: 1px solid var(--app-mid-lighter-2);\n$borderRadius: 5px;\n\n$btnShadow:\n  0 3px 1px -2px rgba(0, 0, 0, 0.2),\n  0 2px 2px 0 rgba(0, 0, 0, 0.14),\n  0 1px 5px 0 rgba(0, 0, 0, 0.12);\n\n$shadow: 0 8px 16px rgba(var(--app-cover-rgb), .15);\n$shadow-sm: 0 4px 8px rgba(var(--app-cover-rgb), .15);\n\n\n// page\n\n$page_minW: 1280px;\n$page_maxW: 1920px;\n$page_maxW-mobile: 800px;\n\n\n// >media queries\n\n// large screens: 1080p, 2K, 4K\n$pageWild_w: $page_maxW;\n\n\n// >padding\n\n$page_pb50: 50px;\n$page_pb20: 20px;\n\n$page_pt20: 20px;\n$page_pt30: 30px;\n\n$page_px: 20px;\n$page_py20: 20px;\n\n$page_p: $page_pt20 $page_px $page_pb50;\n$page_p-v2: $page_pt30 $page_px $page_pb50;\n\n\n$popover_p: 10px 0;\n\n\n\n\n\n\n\n%btn {\n  margin: 0;\n  font-weight: 600;\n}\n\n%cardHead {\n  border-bottom: $borderDivider;\n  padding: 9px 12px;\n\n  color: var(--app-mid-dark);\n  // font-size: 17px;\n  font-weight: 600;\n\n  display: flex;\n  align-items: center;\n\n\n  /* .card-head-btns {\n    margin-left: auto;\n    padding-left: 20px;\n\n    display: flex;\n    align-items: center;\n  } */\n\n  .card-head-icon {\n    margin-right: 10px;\n    // font-size: 20px;\n    font-size: 18px;\n  }\n\n}\n\n%checkbox {\n  // --border-width: 1px;\n  --border-color: rgba(var(--app-mid-light-rgb), .8);\n  --size: 19px;\n\n  // pointer-events: none;\n}\n\n// aka 'quick actions'\n%mapHudBtns {\n  border-radius: $borderRadius;\n\n  --px: 7px;\n  $px: var(--px);\n  padding: 7px $px;\n\n  background-color: var(--app-base);\n  display: flex;\n\n  box-shadow: $shadow;\n\n\n  .hqa-btn-wrap {\n\n    .hqa-btn {\n      margin: 0;\n      --border-radius: 50%;\n\n      --padding-top: 0;\n      --padding-bottom: 0;\n      --padding-start: 0;\n      --padding-end: 0;\n\n      height: auto;\n\n      font-size: 11px;\n\n      .btn-icon {\n        margin: 8px;\n      }\n    }\n\n\n    &:not(:last-child) {\n      margin-right: $px;\n      border-right: $borderDivider;\n      padding-right: $px;\n    }\n  }\n\n  @media (min-width: 360px) {\n    --px: 10px;\n  }\n}\n\n%search {\n  /*\n  --background\tBackground of the searchbar\n  --cancel-button-color\tColor of the searchbar cancel button\n  --clear-button-color\tColor of the searchbar clear button\n  --color\tColor of the searchbar text\n  --icon-color\tColor of the searchbar icon\n  --placeholder-color\tColor of the searchbar placeholder\n  --placeholder-font-style\tFont style of the searchbar placeholder\n  --placeholder-font-weight\tFont weight of the searchbar placeholder\n  --placeholder-opacity\tOpacity of the searchbar placeholder\n  */\n\n  border: $borderDivider;\n  // fix: visual glitch\n  --border-radius: #{$borderRadius};\n  border-radius: $borderRadius;\n\n  padding: 0;\n\n  --box-shadow: none;\n}\n\n%statusCircle {\n  border-radius: 50%;\n\n  height: 10px;\n  width: 10px;\n\n  &.status-off {\n    background-color: var(--app-danger);\n  }\n  &.status-on {\n    background-color: var(--app-succ);\n  }\n}\n\n\n// input\n\n%input {\n  // --background\tBackground of the input\n  // --color\tColor of the input text\n  // --padding-bottom\tBottom padding of the input\n  // --padding-end\tRight padding if direction is left-to-right, and left padding if direction is right-to-left of the input\n  // --padding-start\tLeft padding if direction is left-to-right, and right padding if direction is right-to-left of the input\n  // --padding-top\tTop padding of the input\n  // --placeholder-color\tColor of the input placeholder text\n  // --placeholder-font-style\tFont style of the input placeholder text\n  // --placeholder-font-weight\tFont weight of the input placeholder text\n  // --placeholder-opacity\tOpacity of the input placeholder text\n\n  border: $borderDivider;\n  border-radius: 5px;\n\n  // --padding-top: 10px;\n  // --padding-bottom: 10px;\n  --padding-start: 8px;\n  --padding-end: 8px;\n}\n\n%input-lg {\n  @extend %input;\n\n  $p: 12px;\n  --padding-top: #{$p};\n  --padding-bottom: #{$p};\n  --padding-start: #{$p};\n  --padding-end: #{$p};\n}\n\n\n// modal\n\n%modalFooter {\n  border-top: $borderDivider;\n\tpadding: 10px $page_px;\n\n\tdisplay: flex;\n\tjustify-content: space-between;\n\n\t.foot-btn {\n\t\tmargin: 0;\n    font-weight: 600;\n\n    // .btn-icon {}\n\n    &.mw-120 {\n      min-width: 120px;\n    }\n\t}\n\n\t&::before {\n\t\tcontent: normal;\n\t}\n}\n\n%modalHeader {\n  padding: 15px $page_px;\n  background-color: var(--app-main-darker);\n\n  .head-elem {\n    &.he-title {\n      margin-bottom: 20px;\n\n      &.mb-0 {\n        margin-bottom: 0;\n      }\n    }\n  }\n\n  &.p-20 {\n    padding: $page_py20 $page_px;\n  }\n}\n\n\n// text\n\n%longWord {\n  word-break: break-all;\n  // Edge 79, Firefox 67 - also: deprecated?\n  word-break: break-word;\n}\n\n%oneLiner {\n  white-space: nowrap;\n  overflow-x: hidden;\n  text-overflow: ellipsis;\n}\n\n\n\n\n\n\n\n\n\nion-header,\nion-content,\nion-footer {\n  //font-size: 15px;\n\n  // works but must be done on project setup\n  // some elems already in use need white-space: nowrap;\n  // @extend %longWord;\n}\n\n\n\n\n\n\n// effect\n\n.ion-activatable {\n  position: relative;\n\n  &.ripple-bounded {\n    overflow: hidden;\n  }\n\n\n  & > ion-ripple-effect.ripple {\n\n    &.contr {\n      color: var(--app-contr);\n    }\n\n\n    &.darkest {\n      color: var(--app-darkest);\n    }\n\n    &.lightest {\n      color: var(--app-lightest);\n    }\n\n\n    &.main {\n      color: var(--app-main);\n    }\n\n    &.main-darker {\n      color: var(--app-main-darker);\n    }\n\n    /*&.main-soft {\n      color: var(--app-main-soft);\n    }*/\n\n    &.main-softer {\n      color: var(--app-main-softer);\n    }\n\n    &.main-strong {\n      color: var(--app-main-strong);\n    }\n\n\n    &.mid-light {\n      color: var(--app-mid-light);\n    }\n\n    &.mid-lighter {\n      color: var(--app-mid-lighter);\n    }\n\n    &.mid-lighter-2 {\n      color: var(--app-mid-lighter-2);\n    }\n\n  }//& > ion-ripple-effect.ripple\n\n}//.ion-activatable\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n","\n\n@use \"../../../../../theme/mobile/desktop\" as *;\n// @use \"../../../../../theme/mobile/modal_alarm\"/*  as * */;\n\n// @use \"../../../../../theme/mobile/pageTitleHeader\";\n@use \"../../../../../theme/mobile/pageTitleHeaderCustom\";\n\n\n\n\n// * copied from modal_alarm.scss\n// added 4 mobile\n.page-wrapper {\n\theight: 100%;\n\n\tdisplay: flex;\n\tflex-direction: column;\n\n\t.page-wrap-scrollable {\n\t\tflex: 1;\n\t\toverflow-y: auto;\n\n\t\tdisplay: flex;\n\t\talign-items: flex-start;\n\n\t\tbackground-color: var(--app-light);\n\n\t\t.page {\n\t\t\tmargin: 0 auto;\n\t\t\twidth: 100%;\n\t\t\tmax-width: $page_maxW-mobile;\n\t\t}\n\t}\n\n}\n\n\n\n.page {\n\tpadding: $page_p;\n\t// padding-top: $page_pt30;\n\n\n\t.page-title {\n\t\tmargin-bottom: 30px;\n\t}\n\n\n\t.ticket-form {\n\n\n\t\t.form-grid {\n\t\t\t// display: grid;\n\t\t\t// grid-template-columns: repeat(3, minmax(auto, 350px));\n\t\t\t// gap: 20px 30px;\n\n\n\t\t\t.item {\n\t\t\t\t$p: 0;\n\t\t\t\t--padding-top: #{$p};\n\t\t\t\t--padding-bottom: #{$p};\n\t\t\t\t--padding-start: #{$p};\n\t\t\t\t--padding-end: #{$p};\n\n\t\t\t\t// height: 100%;\n\t\t\t\t// max-height: 20vh;\n\n\t\t\t\twidth: calc(100% + 16px);\n\t\t\t\tvisibility: hidden;\n\n\t\t\t\t.input-field {\n\t\t\t\t\tvisibility: visible;\n\t\t\t\t\tmargin-top: 0;\n\n\t\t\t\t\t// height: 100%;\n\n\t\t\t\t\t$p: 10px;\n\t\t\t\t\t--padding-top: #{$p};\n\t\t\t\t\t--padding-bottom: #{$p};\n\t\t\t\t\t--padding-start: #{$p};\n\t\t\t\t\t--padding-end: #{$p};\n\t\t\t\t}\n\t\t\t}\n\n\n\t\t\t.form-grid-btns {\n\t\t\t\tpadding-top: 30px;\n\n\t\t\t\tdisplay: flex;\n\t\t\t\tflex-direction: column;\n\t\t\t\talign-items: flex-start;\n\t\t\t\tjustify-content: center;\n\n\t\t\t\t.attachment {\n\t\t\t\t\tmargin-bottom: 5px;\n\t\t\t\t\tmax-width: 100%;\n\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\talign-items: center;\n\n\n\t\t\t\t\t.attachment-text {\n\t\t\t\t\t\tflex: 1;\n\n\t\t\t\t\t\tcolor: var(--app-mid);\n\t\t\t\t\t\t// font-weight: 500;\n\n\t\t\t\t\t\t@extend %oneLiner;\n\t\t\t\t\t}\n\n\t\t\t\t\t.line-btn {\n\t\t\t\t\t\tmargin: 0;\n\t\t\t\t\t\tmargin-left: 5px;\n\n\t\t\t\t\t\t--border-radius: 50%;\n\t\t\t\t\t\tborder-radius: 50%;\n\n\t\t\t\t\t\theight: auto;\n\n\t\t\t\t\t\t$p: 0;\n\t\t\t\t\t\t--padding-start: #{$p};\n\t\t\t\t\t\t--padding-end: #{$p};\n\n\t\t\t\t\t\t.btn-icon {\n\t\t\t\t\t\t\tmargin: 5px;\n\t\t\t\t\t\t\tfont-size: 18px;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\t.t1-btn {\n\t\t\t\t\tmargin: 0;\n\t\t\t\t\tmargin-bottom: 20px;\n\n\t\t\t\t\t$p: 15px;\n\t\t\t\t\tmargin-left: -$p;\n\n\t\t\t\t\t--padding-start: #{$p};\n\t\t\t\t\t--padding-end: #{$p};\n\n\t\t\t\t\theight: 34px;\n\n\t\t\t\t\t// --color: var(--app-mid-light);\n\t\t\t\t\tfont-size: 15px;\n\t\t\t\t\ttext-transform: none;\n\n\t\t\t\t\t.btn-icon {\n\t\t\t\t\t\tmargin-left: 20px;\n\t\t\t\t\t\tcolor: var(--app-main);\n\t\t\t\t\t\tfont-size: 20px;\n\t\t\t\t\t}\n\t\t\t\t}\n\n\n\t\t\t}\n\n\n\t\t\t// $mb: 20px;\n\n\t\t\t// copied from modal.scss\n\t\t\t.input-field-wrap {\n\t\t\t\tdisplay: flex;\n\t\t\t\talign-items: center;\n\n\n\t\t\t\t// Aggiunta Vigo\n\t\t\t\tposition: relative;\n\n\t\t\t\tion-textarea{\n\t\t\t\t\t\tmargin-top: 0;\n\t\t\t\t}\n\t\t\t\t.input-error{\n\t\t\t\t\t\tposition: absolute;\n\t\t\t\t\t\ttop: 100%;\n\t\t\t\t\t\tcolor: var(--app-danger);\n\t\t\t\t\t\tpadding: 2px;\n\t\t\t\t}\n\t\t\t\t// Fine aggiunta Vigo\n\n\t\t\t\t.input-field {\n\t\t\t\t\t@extend %input;\n\n\t\t\t\t\tfont-size: 16px;\n\t\t\t\t\tbackground-color: var(--app-base);\n\t\t\t\t\t// max-width: 300px;\n\n\t\t\t\t\t// &.ml-20 {\n\t\t\t\t\t// \tmargin-left: 20px;\n\t\t\t\t\t// }\n\n\t\t\t\t\t// &.mxw-250 {\n\t\t\t\t\t// \tmax-width: 250px;\n\t\t\t\t\t// }\n\n\t\t\t\t\t&.if-textarea {\n\t\t\t\t\t\tmargin-top: 0;\n\n\t\t\t\t\t\t&.if-textarea-msg {\n\n\t\t\t\t\t\t\t// &.show-on-sm {}\n\n\t\t\t\t\t\t\t&.show-standard {\n\t\t\t\t\t\t\t\tdisplay: none;\n\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t@media (min-height: 800px) {\n\t\t\t\t\t\t\t\t&.show-on-sm {\n\t\t\t\t\t\t\t\t\tdisplay: none;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t&.show-standard {\n\t\t\t\t\t\t\t\t\tdisplay: initial;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\n\n\t\t\t\t\t// Aggiunta Vigo\n\t\t\t\t\t&.border-danger{\n\t\t\t\t\t\tborder-color: var(--app-danger);\n\t\t\t\t\t}\n\t\t\t\t\t// Fine aggiunta Vigo\n\n\t\t\t\t}\n\n\t\t\t\t/* .input-field-lg {\n\t\t\t\t\t@extend %input-lg;\n\n\t\t\t\t\t&.fz-15 {\n\t\t\t\t\t\tfont-size: 15px;\n\t\t\t\t\t}\n\n\t\t\t\t\t&.mxw-300 {\n\t\t\t\t\t\tmax-width: 300px;\n\t\t\t\t\t}\n\t\t\t\t\t&.mxw-350 {\n\t\t\t\t\t\tmax-width: 350px;\n\t\t\t\t\t}\n\n\t\t\t\t} */\n\n\n\t\t\t\t/* .input-help {\n\t\t\t\t\tmargin-left: 12px;\n\n\t\t\t\t\t// color: rgba(var(--app-main-softer-rgb), .7);\n\t\t\t\t\tcolor: var(--app-main-softer);\n\n\t\t\t\t\tfont-size: 22px;\n\n\t\t\t\t\t&.ml-15 {\n\t\t\t\t\t\tmargin-left: 15px;\n\t\t\t\t\t}\n\t\t\t\t\t&.ml-20 {\n\t\t\t\t\t\tmargin-left: 20px;\n\t\t\t\t\t}\n\t\t\t\t} */\n\n\n\t\t\t\t/* .input-unit {\n\t\t\t\t\tmargin-left: 12px;\n\n\t\t\t\t\tcolor: rgba(var(--app-mid-rgb), .7);\n\n\t\t\t\t\tfont-size: 14px;\n\t\t\t\t\tfont-weight: 500;\n\t\t\t\t} */\n\n\n\t\t\t\t&.w-stacked-lbl {\n\t\t\t\t\tflex-direction: column;\n\t\t\t\t\talign-items: flex-start;\n\n\t\t\t\t\t.input-field-lbl {\n\t\t\t\t\t\t@extend %longWord;\n\n\t\t\t\t\t\t// color: var(--app-mid-dark);\n\t\t\t\t\t\tcolor: var(--app-mid-light);\n\t\t\t\t\t\t// font-size: 14px;\n\t\t\t\t\t\t// font-size: 15px;\n\t\t\t\t\t\tfont-weight: 500;\n\n\t\t\t\t\t\t&.mb-0 {\n\t\t\t\t\t\t\tmargin-bottom: 0;\n\t\t\t\t\t\t}\n\t\t\t\t\t\t&.mb-5 {\n\t\t\t\t\t\t\tmargin-bottom: 5px;\n\t\t\t\t\t\t}\n\t\t\t\t\t\t&.mb-10 {\n\t\t\t\t\t\t\tmargin-bottom: 10px;\n\t\t\t\t\t\t}\n\t\t\t\t\t\t&.mb-15 {\n\t\t\t\t\t\t\tmargin-bottom: 15px;\n\t\t\t\t\t\t}\n\t\t\t\t\t\t&.mb-20 {\n\t\t\t\t\t\t\tmargin-bottom: 20px;\n\t\t\t\t\t\t}\n\t\t\t\t\t\t&.mb-25 {\n\t\t\t\t\t\t\tmargin-bottom: 25px;\n\t\t\t\t\t\t}\n\t\t\t\t\t\t&.mb-30 {\n\t\t\t\t\t\t\tmargin-bottom: 30px;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\n\t\t\t\t}\n\n\n\t\t\t\t// &:not(:last-child) {\n\t\t\t\t// \tmargin-bottom: $mb;\n\t\t\t\t// }\n\n\t\t\t\t// ? can this be done better w/ Sass syntax?\n\t\t\t\t&.mb-0 {\n\t\t\t\t\tmargin-bottom: 0;\n\t\t\t\t}\n\t\t\t\t&.mb-5 {\n\t\t\t\t\tmargin-bottom: 5px;\n\t\t\t\t}\n\t\t\t\t&.mb-10 {\n\t\t\t\t\tmargin-bottom: 10px;\n\t\t\t\t}\n\t\t\t\t&.mb-15 {\n\t\t\t\t\tmargin-bottom: 15px;\n\t\t\t\t}\n\t\t\t\t&.mb-20 {\n\t\t\t\t\tmargin-bottom: 20px;\n\t\t\t\t}\n\t\t\t\t&.mb-25 {\n\t\t\t\t\tmargin-bottom: 25px;\n\t\t\t\t}\n\t\t\t\t&.mb-30 {\n\t\t\t\t\tmargin-bottom: 30px;\n\t\t\t\t}\n\n\t\t\t\t// &.mxw-350 {\n\t\t\t\t// \tmax-width: 350px;\n\t\t\t\t// }\n\n\t\t\t}\n\n\n\t\t\t.grid-col-2 {\n\t\t\t\tgrid-column: span 2;\n\t\t\t}\n\t\t\t.grid-row-2 {\n\t\t\t\tgrid-row: span 2;\n\t\t\t}\n\n\t\t}\n\n\n\n\t\t.form-btns {\n\t\t\tpadding-top: 20px;\n\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\n\t\t\t.tfb-btn {\n\t\t\t\tmargin: 0;\n\t\t\t\tfont-weight: 600;\n\n\t\t\t\tfont-size: 16px;\n\n\t\t\t\t.btn-icon {\n\t\t\t\t\tmargin-left: 12px;\n\t\t\t\t\tfont-size: 16px;\n\t\t\t\t}\n\t\t\t}\n\n\t\t}\n\n\n\t\t&.style-2 {\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: center;\n\n\t\t\t.form-grid {\n\t\t\t\twidth: 100%;\n\t\t\t\tmax-width: 500px;\n\t\t\t}\n\t\t}\n\n\t}\n\n\n\n}\n\n\n\n.pg-footer {\n\t@extend %modalFooter;\n\n\t.foot-btn {\n\t\tmin-width: 130px;\n\t}\n}\n\n\n\n\n\n\n\n\n\n\n\n\n\n","\n@use \"desktop\" as *;\n\n\n.page-title-header-custom {\n\tmin-height: 56px;\n\n\tdisplay: flex;\n\talign-items: center;\n\n\tbackground-color: var(--app-main-strong);\n\tcolor: var(--app-base);\n\n\tbox-shadow: 0 1px 2px rgba(var(--app-cover-rgb), .6);\n\n\n\t.head-btn {\n\t\tmargin: 0;\n\t\tborder-radius: 50%;\n\t\t--border-radius: 50%;\n\t}\n\n\n\t.ptc-title {\n\t\tflex: 1;\n\t\tpadding: 0 $page_px;\n\n\t\tletter-spacing: 0.0125em;\n\t\tfont-size: 20px;\n\t\tfont-weight: 600;\n\t}\n\n\n\t.ptc-step {\n\t\tmargin-right: $page_px;\n\n\t\tborder: 1px solid var(--app-base);\n\t\tborder-radius: 99px;\n\t\tpadding: 2px 6px;\n\n\t\tfont-size: 14px;\n\t\tfont-weight: 500;\n\n\t\tdisplay: flex;\n\t\talign-items: center;\n\n\n\t\t.mini-lbl {\n\t\t\tdisplay: none;\n\n\t\t\tpadding-top: 1px;\n\t\t\tpadding-right: 5px;\n\n\t\t\tfont-size: 11px;\n\t\t\ttext-transform: uppercase;\n\t\t}\n\n\t\t@media (min-width: 360px) {\n\t\t\t.mini-lbl {\n\t\t\t\tdisplay: initial;\n\t\t\t}\n\t\t}\n\n\t}\n\n\n\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
